import React from 'react'

import { Button, Icon } from 'antd'

import { CustomBreadcrumb } from '../../../components/CustomBreadcrumb/CustomBreadcrumb'
import { RULES, validRule } from '../../../constants/Entitlements'
import { getMessage } from '../../../util/IntlMessages'
import { hasEditAccess } from '../utils'

const Header = ({ match, history, walletStatusId, state, addElectToListButtonClick, loggedUser }) => {
  const hasAccess = validRule(RULES.CUSTOMER_LINKS) && hasEditAccess(walletStatusId, loggedUser)

  return (
    <div className="default-header-div">
      <div className="default-header-breadcrumb">
        <CustomBreadcrumb match={match} history={history} />
        <div className="default-header-buttons">
          <Button className="button-return" onClick={() => history.goBack()}>
            <Icon type="left" theme="outlined" className="default-back-icon" />
            {getMessage('back')}
          </Button>
          {hasAccess && (
            <Button type="primary" onClick={addElectToListButtonClick}>
              {state.memberData.customers_count ? getMessage('addElectToList') : getMessage('register')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
